export default function Certification() {

    return (
        <>
            <section id="certification-section">
                {/* <div className="certification-container"> */}
                <div className="certification-header">
                    <h2 className="section-title">Certification We Prepare For</h2>
                    <p className="section-subtitle">Internationally recognized music certifications to advance your career</p>
                </div>

                <div className="certification-logos">
                    <div className="certification-item">
                        <div className="certification-logo">
                            <div className="logo-box">
                                <img src="/images/company-logos/Rock School London.jpeg" alt="Rock School London" />
                            </div>
                            <span className="logo-name">Rock School London</span>
                        </div>
                    </div>

                    <div className="certification-item">
                        <div className="certification-logo">
                            <div className="logo-box">
                                <img src="/images/company-logos/ABRSM.png" alt="ABRSM" />
                            </div>
                            <span className="logo-name">ABRSM</span>
                        </div>
                    </div>

                    <div className="certification-item">
                        <div className="certification-logo">
                            <div className="logo-box">
                                <img src="/images/company-logos/Music Teachers Board.png" alt="Music Teachers' Board" />
                            </div>
                            <span className="logo-name">Music Teachers Board</span>
                        </div>
                    </div>

                    <div className="certification-item">
                        <div className="certification-logo">
                            <div className="logo-box">
                                <img src="/images/company-logos/Trinity College London.png" alt="Trinity College London" />
                            </div>
                            <span className="logo-name">Trinity College London</span>
                        </div>
                    </div>

                    <div className="certification-item">
                        <div className="certification-logo">
                            <div className="logo-box">
                                <img src="/images/company-logos/Trinity Rock & Pop.png" alt="Trinity Rock & Pop" />
                            </div>
                            <span className="logo-name">Trinity Rock & Pop</span>
                        </div>
                    </div>
                    {/* </div> */}
                </div>
            </section>
        </>
    );
} 